import axios from "axios";
import { urlRequest } from "../components/constants";

export const getResidents = async (e) => {
  let url = urlRequest + "users/getresidentes";
  let tokenSend = localStorage.getItem("token");
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenSend}`,
  };
  return await axios
    .get(url, { headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      alert("Error al recibir los residentes");
    });
};
